"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CarIcon = require("./CarIcon");

var _CarIcon2 = _interopRequireDefault(_CarIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CarIcon2.default;